module.exports = __webpack_public_path__ + "assets/img/15.fa385da5.png";